import { motion } from "framer-motion";
import SceneShell from "../components/SceneShell";

/**
 * Scene 35 — Quiz time. Two relatable questions for the room.
 * The "that's the gap. that's the product." reveal moved to script.
 */

const questions = [
  "Who here has clients that struggle to stay consistent on social?",
  "Who here has branches that should be visible locally… but just aren't?",
];

export default function Scene35_QuizTime() {
  return (
    <SceneShell variant="forest" align="left" data-testid="scene-quiz-time">
      <div className="relative max-w-[1500px] mx-auto w-full">
        <div className="space-y-10 max-w-[1300px]">
          {questions.map((q, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -24, filter: "blur(8px)" }}
              animate={{ opacity: 1, x: 0, filter: "blur(0px)" }}
              transition={{
                duration: 1.0,
                delay: 0.3 + i * 0.7,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="flex items-start gap-6"
              data-testid={`quiz-question-${i}`}
            >
              <span
                className="kn-display text-3xl sm:text-4xl lg:text-5xl tnum shrink-0"
                style={{ color: "#e9a820", fontWeight: 800 }}
              >
                0{i + 1}
              </span>
              <h2
                className="kn-display text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.1]"
                style={{ fontWeight: 700 }}
              >
                "{q}"
              </h2>
            </motion.div>
          ))}
        </div>
      </div>
    </SceneShell>
  );
}
